module.exports = __webpack_public_path__ + "static/media/logo-sing@2x.14b23cbd.png";